import { Box, Container } from "@mui/system";
import * as React from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import UpcomingCard from "../../../components/reservation/UpcomingCard";

import { Grid } from "@mui/material";

import { useLocation, useNavigate } from "react-router";
import MenuAppBar from "../../ownersDashboard/dashboardNavBar";
import CustomSerachBar from "../../../components/CustomSerachBar";
import { useDispatch, useSelector } from "react-redux";
import {
  getLocationSolrListApi,
  saveReservationStateData,
  getReserverationList,
  getLocationGatesList,
  setSelectedReservationItem,
  setSelectedGates,
  doOpenGate,
  reservationsDetailsRequest,
} from "../../../redux/reservations/action";
import CustomLoader from "../../../components/CustomLoader";
import BookReservationCard from "../../../components/reservation/BookReservationCard";
import PastReservationCard from "../../../components/reservation/PastReservationCard";
import MenuBar from "../../menuBar";
import { useResponsive } from "../../../hooks/useResponsive";
import storePersist, { localConstant } from "../../../services/localStorage";
import BottomNav from "../../../components/BottomNav/BottomNav";
import InfiniteScroll from "react-infinite-scroller";
import { useEffect } from "react";
import { updateReservationCheckout } from "../../../redux/reservations/constants";
import { useTranslation } from "react-i18next";
import { sendMessageToReactNative } from "../../../utils";
import { useState } from "react";
import Alert from "../../../components/Alert";
import FullPageModal from "../../../components/FullPageLoader";

const ReservationVehical = () => {
  const {
    isLoading,
    locationData,
    reservationList,
    gateList,
    selectedReservation,
  } = useSelector((state) => state.reservationReducer);
  const userType = storePersist.get(localConstant.USER_PROFILE);

  const location = useLocation();
  const navigate = useNavigate();
  const [gateOpenLoading, setGateOpenLoading] = useState(false);
  const { t } = useTranslation();

  const [value, setValue] = React.useState(userType === "OWNER" ? "1" : "2");

  const dispatch = useDispatch();
  const lgUp = useResponsive("up", "lg");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const setGateLoadingState = (state) => {
    setGateOpenLoading(state);
  };

  const [dialogProps, setDialogProps] = useState({
    isOpen: false,
    content: "",
    reset: () =>
      setDialogProps((prev) => ({
        ...prev,
        isOpen: false,
        content: "",
      })),
  });

  React.useEffect(() => {
    if (location?.state == null && userType !== "OWNER") {
      setValue("2");
    } else if (
      (userType === "OWNER" &&
        location?.state == null &&
        reservationList?.length > 0) ||
      location?.state?.tabType === "Active"
    ) {
      // This condition will work, if active reservations exist or returning back from reservation details to active tab.
      setValue("2");
    } else if (location?.state?.tabType === "Past") {
      setValue("3");
    } else {
      setValue("1");
    }
  }, [location?.state?.tabType]);

  React.useEffect(() => {
    // dispatch(getLocationList({}, (response) => {}));
    if (userType !== "OWNER") return;
    if (
      storePersist.get(localConstant.AGREEMENT_STATUS) === "IN_PRGRS" ||
      storePersist.get(localConstant.AGREEMENT_STATUS) === "IN_PROGESS"
    ) {
      return setDialogProps((prev) => ({
        ...prev,
        isOpen: true,
        content:
          "Esign for the agreement is still under progress. Please try again after some time !",
      }));
    } else if (
      storePersist.get(localConstant.USER_PROFILE) === "OWNER" &&
      storePersist.get(localConstant.AGREEMENT_STATUS) !== "COMPLTD" &&
      storePersist.get(localConstant.AGREEMENT_STATUS) !== "COMPLETED"
    ) {
      return setDialogProps((prev) => ({
        ...prev,
        isOpen: true,
        content: t("pages.makeReservation.text06"),
      }));
    }

    const params = {
      "q.op": "OR",
      start: "0",
      rows: "10000",
      wt: "json",
      cl: "OPS",
      sort: "location_city asc",
    };

    dispatch(getLocationSolrListApi(params, (response) => {}));
    dispatch(updateReservationCheckout({}));
  }, []);

  React.useEffect(() => {
    const custId = storePersist.get(localConstant.ENTITY_CUSTOMER_ID);
    let params = {
      "q.op": "OR",
      start: "0",
      rows: "10000",
      wt: "json",
      cl: "OPS",
    };
    if (value === "2") {
      params = {
        ...params,
        sort: "reservation_from_date asc",
        fq: `reservation_status: (PNDG_COUT CONFIRMED PNDG_CONF PNDG_EXT OVRST_CONF)`,
      };
    } else if (value === "3") {
      params = {
        ...params,
        sort: "reservation_to_date desc",
        fq: `reservation_status: (CHCKD_OUT CANCELLED ENDED)`,
      };
    }
    if (value === "2" || value === "3") {
      dispatch(getReserverationList(params, (response) => {}));
    }

    if (value === "1") {
      const SearchParams = {
        "q.op": "OR",
        start: "0",
        rows: "10000",
        wt: "json",
        cl: "OPS",
        sort: "location_city asc",
      };

      dispatch(getLocationSolrListApi(SearchParams, (response) => {}));
    }
  }, [value]);

  const [tempData, setTempData] = React.useState([]);
  const [pointer, setPointer] = React.useState(1);
  useEffect(() => {
    setTempData([]);
  }, [locationData]);

  const fetchData = () => {
    if (locationData?.length > tempData?.length) {
      setTempData([...locationData.slice(0, 9 * pointer)]);
      setPointer(pointer + 1);
    }
  };
  React.useEffect(() => {
    if (reservationList?.length > 0) {
      const uniq = {};
      for (let index = 0; index < reservationList?.length; index++) {
        const element = reservationList[index];
        if (element.location_id && element.reservation_status === "CONFIRMED") {
          const locationId = element.location_id;
          if (!Object.keys(uniq).includes(locationId)) {
            uniq[locationId] = locationId;
          }
        }
      }
      const locations = Object.keys(uniq).toString().replace(/,/g, " ");
      if (Object.keys(uniq)?.length > 0) {
        const params = {
          fq: `location_id: (${locations})&fq=equipment_type_code:GATE&fq=equipment_status_code:ACTIVE&start=0&rows=10000`,
        };
        dispatch(getLocationGatesList(params, (response) => {}));
      }
    }
  }, [reservationList]);
  const onMessageFromRN = (message) => {
    try {
      const { action, payload } = JSON.parse(message);
      if (action === "User_Location") {
        setGateOpenLoading(true);
        dispatch(
          doOpenGate(
            {
              lat: payload?.coords?.latitude,
              lng: payload?.coords?.longitude,
              gateId: selectedReservation?.equipment_id || "",
              reservationId: selectedReservation?.reservation_id,
            },
            (response) => {
              console.log("doOpenGate Response:", response);
            },
            setGateLoadingState,
          ),
        );
      }
    } catch (error) {
      console.error("Error parsing message:", error);
    }
  };
  // Attach the handler to `window` so we can access it from
  // scripts injected by React Native WebView.
  window.onMessageFromRN = onMessageFromRN;
  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <MenuAppBar title={t("pages.reservation.pageHeading")} />
      <MenuBar activeTab={1} />
      <Grid disableGutters sx={{ px: 0, m: 0, mb: 5 }}>
        <Box
          sx={{
            minHeight: 1,
            display: "flex",
            flexDirection: "column",
          }}
          width={"100%"}
          maxHeight={"90vh"}
          overflow={"scroll"}
          justifyContent={"center"}
        >
          <Box
            sx={{
              width: "100%",

              justifyContent: "center",
              minHeight: "60vh",
              overflow: "auto",
            }}
          >
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  {userType === "OWNER" && (
                    <Tab
                      label={t("pages.reservation.tab01")}
                      style={{ flex: 1 }}
                      value="1"
                    />
                  )}
                  <Tab
                    label={t("pages.reservation.tab02")}
                    style={{ flex: 1 }}
                    value="2"
                  />
                  <Tab
                    label={t("pages.reservation.tab03")}
                    style={{ flex: 1 }}
                    value="3"
                  />
                </TabList>
              </Box>
              {userType === "OWNER" && (
                <TabPanel value="1">
                  <CustomSerachBar
                    tiltle={t("pages.reservation.title01")}
                    onSearchClick={(serachText) => {
                      const paramsSearch = {
                        "q.op": "OR",
                        start: "0",
                        rows: "10000",
                        wt: "json",
                        cl: "OPS",
                        q: serachText,
                      };

                      const paramsNoSearch = {
                        "q.op": "OR",
                        start: "0",
                        rows: "10000",
                        wt: "json",
                        cl: "OPS",
                      };
                      const searchParams = serachText
                        ? paramsSearch
                        : paramsNoSearch;

                      dispatch(
                        getLocationSolrListApi(searchParams, (response) => {}),
                      );
                    }}
                  />
                  <InfiniteScroll
                    // style={{ margin: "10px" }}
                    pageStart={0}
                    loadMore={() => fetchData()}
                    hasMore={true}
                    loader={
                      <div className="loader" key={0}>
                        {/* Loading ... */}
                      </div>
                    }
                  >
                    <Grid container rowSpacing={1} columnSpacing={1}>
                      {tempData?.length > 0 &&
                        tempData?.map((item, index) => {
                          return (
                            <Grid item xs={12} sm={6} lg={4}>
                              <BookReservationCard
                                key={index}
                                data={item}
                                onClick={() => {
                                  dispatch(saveReservationStateData(item));
                                  navigate("/makeReservation", {
                                    state: {
                                      ...item,
                                      ...{ from: "/reservation" },
                                    },
                                  });
                                }}
                              />
                            </Grid>
                          );
                        })}
                    </Grid>
                  </InfiniteScroll>
                </TabPanel>
              )}
              <TabPanel value="2">
                <Grid container rowSpacing={1} columnSpacing={1}>
                  {reservationList?.length > 0 ? (
                    reservationList?.map((item, index) => {
                      return (
                        <Grid item xs={12} sm={6} lg={4} key={index}>
                          <UpcomingCard
                            data={item}
                            gateList={gateList}
                            openGate={(gate) => {
                              setGateOpenLoading(true);
                              let { equipment_id } = gate || {};
                              dispatch(
                                setSelectedReservationItem({
                                  ...item,
                                  equipment_id,
                                }),
                              );
                              sendMessageToReactNative("GET_DEVICE_LOCATION");
                            }}
                            onPressPayNow={(gates) => {
                              dispatch(setSelectedGates(gates));
                              dispatch(setSelectedReservationItem(item));
                              dispatch(
                                reservationsDetailsRequest(
                                  item?.reservation_id,
                                  (response) => {
                                    navigate("/makePayment", {
                                      state: {
                                        ...response,
                                        hideCancel: true,
                                        billing: {
                                          charges: [
                                            {
                                              totalAmount:
                                                response?.billing?.[0]
                                                  ?.dueAmount,
                                              billNums:
                                                response?.billing?.[0]
                                                  ?.dueBillNums,
                                            },
                                          ],
                                        },
                                        reservationId: response?.reservationId,
                                      },
                                    });
                                  },
                                ),
                              );
                            }}
                            onPress={(gates) => {
                              dispatch(setSelectedGates(gates));
                              dispatch(setSelectedReservationItem(item));
                              dispatch(
                                reservationsDetailsRequest(
                                  item?.reservation_id,
                                  (response) => {
                                    navigate("/reservation_details", {
                                      state: {
                                        spotData: response,
                                        from: "/reservation",
                                      },
                                    });
                                  },
                                ),
                              );
                            }}
                          />
                        </Grid>
                      );
                    })
                  ) : (
                    <p>{t("pages.reservation.text04")}</p>
                  )}
                </Grid>
              </TabPanel>
              <TabPanel value="3">
                <Grid container rowSpacing={1} columnSpacing={1}>
                  {reservationList?.length ? (
                    reservationList?.map((item, index) => {
                      return (
                        <Grid item xs={12} sm={6} lg={4} key={index}>
                          <PastReservationCard
                            data={item}
                            onClick={() => {
                              navigate("/makeReservation");
                            }}
                            onPress={(gates) => {
                              dispatch(setSelectedGates(gates));
                              dispatch(setSelectedReservationItem(item));
                              dispatch(
                                reservationsDetailsRequest(
                                  item?.reservation_id,
                                  (response) => {
                                    navigate("/reservation_details", {
                                      state: {
                                        spotData: response,
                                        from: "/reservation",
                                      },
                                    });
                                  },
                                ),
                              );
                            }}
                            onPressPayNow={(gates) => {
                              dispatch(setSelectedGates(gates));
                              dispatch(setSelectedReservationItem(item));
                              dispatch(
                                reservationsDetailsRequest(
                                  item?.reservation_id,
                                  (response) => {
                                    navigate("/makePayment", {
                                      state: {
                                        ...response,
                                        hideCancel: true,
                                        billing: {
                                          charges: [
                                            {
                                              totalAmount:
                                                response?.billing?.[0]
                                                  ?.dueAmount,
                                              billNums:
                                                response?.billing?.[0]
                                                  ?.dueBillNums,
                                            },
                                          ],
                                        },
                                        reservationId: response?.reservationId,
                                      },
                                    });
                                  },
                                ),
                              );
                            }}
                          />
                        </Grid>
                      );
                    })
                  ) : (
                    <p>{t("pages.reservation.text05")}</p>
                  )}
                </Grid>
              </TabPanel>
            </TabContext>
          </Box>
        </Box>
        <BottomNav activeTab={1} />
        {dialogProps.isOpen && <Alert {...dialogProps} />}
        {isLoading && <CustomLoader />}
        {gateOpenLoading && <FullPageModal />}
      </Grid>
    </div>
  );
};

export default ReservationVehical;
